<template>
    <m-pageframe title="Toll-Free Registration">
        <v-container v-if="profile != null" class="px-4" fluid>
            <link-back :to="{ name: 'admin-search-redchirp-numbers' }">
                Back to RedChirp Number Search
            </link-back>

            <div class="text-center mt-4 mb-6">
                <h1>Toll-Free Registration</h1>
                <p class="grey--text text-subtitle-1">{{ pretty_endpoint }}</p>
            </div>

            <v-expansion-panels v-model="open_panel" accordion flat class="d-flex flex-column gap-2 mt-4">
                <v-expansion-panel>
                    <v-expansion-panel-header class="text-h6 shaded-light">
                        Page 1: Message Sender Information
                    </v-expansion-panel-header>

                    <v-expansion-panel-content>
                        <div class="pt-4">
                            <m-edit-text
                                label="Bandwidth Customer Name"
                                value="RedChirp, LLC"
                                read_only
                                copy_check
                            />
                
                            <m-edit-text
                                label="Bandwidth Customer Account ID"
                                value="5006620"
                                read_only
                                copy_check
                            />
                
                            <m-edit-text
                                label="Bandwidth Customer Email Address (for Status Updates)"
                                value="Jennie.Gilbert@RedChirp.com"
                                read_only
                                copy_check
                            />
                
                            <v-row>
                                <v-col>
                                    <m-edit-text
                                        label="Message Sender: Legal Company Name"
                                        :value="profile.brand.legal_company_name"
                                        read_only
                                        copy_check
                                    />
                                </v-col>
                                <v-col>
                                    <m-edit-text
                                        label="Message Sender: DBA (Doing Business As)"
                                        :value="profile.brand.dba"
                                        read_only
                                        copy_check
                                    />
                                </v-col>
                            </v-row>
                
                            <v-row class="mt-0">
                                <v-col>
                                    <m-edit-text
                                        label="Message Sender Entity Type"
                                        :value="legal_form_map[profile.brand.legal_form] || profile.brand.legal_form"
                                        read_only
                                        copy_check
                                    />
                                </v-col>
                                <v-col>
                                    <m-edit-text
                                        label="Message Sender Business Registration Type"
                                        value="EIN"
                                        read_only
                                        copy_check
                                    />
                                </v-col>
                            </v-row>
                
                            <m-edit-text
                                label="Business Registration Number (BRN)"
                                :value="formatted_ein"
                                read_only
                                copy_check
                            />
                
                            <m-edit-text
                                label="Message Sender: URL/Website"
                                :value="profile.brand.website_provided_by_customer"
                                read_only
                                copy_check
                            />
                
                            <m-edit-text
                                label="Message Sender: Privacy Policy"
                                :value="profile.url_privacy_policy"
                                read_only
                                copy_check
                            />
                
                            <div
                                v-if="profile.url_underlying_privacy_policy == null"
                                class="mb-4"
                            >
                                <strong style="color: red">The client has not provided a privacy policy url -- required to pass verification.</strong>
                            </div>
                            <div v-else class="mb-4">
                                To view the client's privacy policy <a target="_blank" :href="profile.url_underlying_privacy_policy">click here</a>
                            </div>
                
                            <m-edit-text
                                label="Message Sender: Terms and Conditions"
                                :value="profile.url_terms_and_conditions"
                                read_only
                                copy_check
                            />
                
                            <div
                                v-if="profile.url_underlying_terms_and_conditions == null"
                                class="mb-4"
                            >
                                <strong style="color: red">The client has not provided a terms and conditions url -- required to pass verification.</strong>
                            </div>
                            <div v-else class="mb-4">
                                To view the client's terms and conditions <a target="_blank" :href="profile.url_underlying_terms_and_conditions">click here</a>
                            </div>
                
                            <h3 class="mt-5 mb-3">Message Sender Primary Company Address or Corporate Headquarters</h3>
                
                            <v-row>
                                <v-col>
                                    <m-edit-text
                                        label="Address Line 1"
                                        :value="profile.brand.address"
                                        read_only
                                        copy_check
                                    />
                                </v-col>
                                <v-col>
                                    <m-edit-text
                                        label="Address Line 2"
                                        :value="null"
                                        read_only
                                        copy_check
                                    />
                                </v-col>
                            </v-row>
                
                            <v-row>
                                <v-col cols="4">
                                    <m-edit-text
                                        label="City"
                                        :value="profile.brand.city"
                                        read_only
                                        copy_check
                                    />
                                </v-col>
                                <v-col cols="4">
                                    <m-edit-text
                                        label="State/Province"
                                        :value="profile.brand.state"
                                        read_only
                                        copy_check
                                    />
                                </v-col>
                                <v-col cols="4">
                                    <m-edit-text
                                        label="ZIP / Postal"
                                        :value="profile.brand.zip"
                                        read_only
                                        copy_check
                                    />
                                </v-col>
                            </v-row>
                
                            <h3 class="mt-5 mb-3">Business Contact</h3>
                
                            <v-row>
                                <v-col>
                                    <m-edit-text
                                        label="Business Contact: First Name"
                                        :value="profile.business_contact_first_name"
                                        read_only
                                        copy_check
                                    />
                                </v-col>
                                <v-col>
                                    <m-edit-text
                                        label="Business Contact: Last Name"
                                        :value="profile.business_contact_last_name"
                                        read_only
                                        copy_check
                                    />
                                </v-col>
                            </v-row>
                
                            <v-row>
                                <v-col>
                                    <m-edit-text
                                        label="Business Contact: Phone"
                                        :value="profile.brand.support_phone_number"
                                        read_only
                                        copy_check
                                    />
                                </v-col>
                                <v-col>
                                    <m-edit-text
                                        label="Business Contact: Email"
                                        :value="profile.brand.support_email_address"
                                        read_only
                                        copy_check
                                    />
                                </v-col>
                            </v-row>
                        </div>
                    </v-expansion-panel-content>
                </v-expansion-panel>

                <v-expansion-panel>
                    <v-expansion-panel-header class="text-h6 shaded-light">
                        Page 2: Campaign Information
                    </v-expansion-panel-header>

                    <v-expansion-panel-content>
                        <div class="pt-4">
                            <m-edit-text
                                label="Estimated Monthly Message Volume"
                                value="10,000"
                                read_only
                                copy_check
                            />
                
                            <m-edit-text
                                label="How many numbers are you attempting to verify on this request?"
                                :value="1"
                                read_only
                                copy_check
                            />
                
                            <m-edit-text
                                label="Phone Number associated with this campaign"
                                :value="pretty_endpoint"
                                read_only
                                copy_check
                            />
                
                            <m-edit-text
                                label="Please choose the category that best represents your use case/content"
                                value="Mixed"
                                read_only
                                copy_check
                            />
                
                            <m-edit-text
                                label="Use Case Summary"
                                :value="profile.campaign_description"
                                read_only
                                copy_check
                            />
                
                            <m-edit-text
                                label="How is opt-in collected?"
                                value="Online"
                                read_only
                                copy_check
                            />
                
                            <m-edit-text
                                label="Please provide URL of opt-in image"
                                :value="profile.brand.website_rc_opt_in_form"
                                read_only
                                copy_check
                            />
                
                            <m-edit-text
                                label="Please provide supporting information of how opt-in is collected"
                                :value="profile.call_to_action"
                                read_only
                                copy_check
                            />
                
                            <div class="production-messages-container">
                                <div class="label">Production Messages</div>
                                <div class="value">
                                    <div 
                                        ref="production_messages"
                                        class="text"
                                    >
                                        <template v-for="(item, index) in sample_messages_limited">{{ item }}
                                            <br v-if="index < sample_messages_limited.length - 1" :key="index">
                                            <br v-if="index < sample_messages_limited.length - 1" :key="'br2-'+index">
                                        </template>
                                    </div>
                                    <div class="icon">
                                        <v-icon v-on:click="onClickCopyProductionMessages">
                                            {{ production_messages_copy_icon }}
                                        </v-icon>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </v-expansion-panel-content>
                </v-expansion-panel>
            </v-expansion-panels>
        </v-container>
    </m-pageframe>
</template>

<script>
export default {
    data() {
        return {
            profile: null,
            open_panel: 0,
            legal_form_map: {
                'Private Company': 'PRIVATE_PROFIT',
                'Public Company': 'PUBLIC_PROFIT',
                'Sole Proprietor': 'SOLE_PROPRIETOR',
                'Government': 'GOVERNMENT',
                'Non-Profit Organization': 'NON_PROFIT',
            },
            productionMessagesCopied: false,
        }
    },

    computed: {
        pretty_endpoint() {
            const endpoint = this.$route.params.endpoint;
            if (!endpoint) return null;
            return this.$rc.pretty(endpoint, 'endpoint');
        },

        formatted_ein() {
            const ein = this.profile?.brand?.ein;
            if (!ein) return null;
            return `${ein.slice(0, 2)}-${ein.slice(2)}`;
        },

        sample_messages_limited() {
            const messages = this.profile?.sample_messages;
            if (!messages || !Array.isArray(messages)) return [];
            return messages.slice(0, 3);
        },

        production_messages_copy_icon() {
            return this.productionMessagesCopied ? 'mdi-check-bold' : 'mdi-content-copy';
        },
    },

    methods: {
        onClickCopyProductionMessages() {
            this.productionMessagesCopied = true;
            const textToCopy = this.sample_messages_limited.join('\n\n');
            navigator.clipboard.writeText(textToCopy);
            this.$rc.snackbar('Production Messages has been copied to clipboard.', 1000);
        },
    },

    mounted () {
        this.$rc.rest({
            spinner: false,
            endpoint: 'PUT: /api/v1/welcome/tcr-campaign-registration/get-profile',
        
            params : {
                organization_id: this.$route.params.organization_id,
            },
        
            on_success: (data) => {
                this.profile = data;
            },

            on_error: 'Unable to get toll-free verification profile',
        });
    },
}
</script>

<style lang="scss" scoped>
:deep(.v-expansion-panel-header),
:deep(.v-expansion-panel-content) {
    border: 1px solid #eee;
    border-radius: var(--border-radius-default);
}
:deep(.v-expansion-panel-header) {
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
}
:deep(.v-expansion-panel-content) {
    border-top: none;
}
.production-messages-container {
    margin-bottom: 3rem;

    .label {
        color: rgba(0,0,0,0.38);
        font-family: Roboto, sans-serif;
        font-size: 12px;
    }

    .value {
        margin-bottom: 15px;
        display: flex;
        flex-direction: row;
    }

    .text {
        border-bottom: 1px dotted rgba(0,0,0,0.48);
        flex-grow: 1;
    }

    .icon {
        margin-left: 12px;
        flex-grow: 0;
    }
}
</style>
